(function() {
  var SUPABASE_URL = 'https://oqafdbaznfhshsteskhw.supabase.co';
  var SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...';
  var STORE_ID = '28432269391';

  var styleElement = document.createElement('style');
  styleElement.innerHTML = '.saleyla-eta-card { ... }'; // Your styles
  document.head.appendChild(styleElement);

  function loadETA() {
    fetch(SUPABASE_URL + '/rest/v1/app_settings?store_id=eq.' + STORE_ID + '&select=default_lead_time_days,vacation_mode,vacation_start,vacation_end', {
      headers: {
        'apikey': SUPABASE_ANON_KEY,
        'Authorization': 'Bearer ' + SUPABASE_ANON_KEY
      }
    })
    .then(function(response) { return response.json(); })
    .then(function(settings) {
      var leadTime = settings[0] ? settings[0].default_lead_time_days : 14;
      var today = new Date();
      var eta = new Date(today);
      eta.setDate(today.getDate() + leadTime);
      var estimatedDate = eta.toLocaleDateString();

      var container = document.getElementById('saleyla-eta-product');
      container.innerHTML = '<div class="saleyla-eta-card"> ... </div>';
    })
    .catch(function(error) {
      console.error('Failed to load Saleyla ETA:', error);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadETA);
  } else {
    loadETA();
  }
})();
